import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { TaxClassificationsApiRepository } from '../repositories/tax-classifications-api.repository';
import { TaxClassificationsCacheRepository } from '../repositories/tax-classifications-cache.repository';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class TaxClassificationsProvider {
    constructor(
        private taxClassificationsApiRepository: TaxClassificationsApiRepository,
        private taxClassificationsCacheRepository: TaxClassificationsCacheRepository
    ) {}

    find(classification: string, isLegalPerson: boolean): Observable<Transaction<string[]>> {
        const cacheId = this.taxClassificationsCacheRepository.getKey(classification + isLegalPerson);

        return concat(
            this.taxClassificationsCacheRepository.load(cacheId),
            this.taxClassificationsApiRepository.load(classification, isLegalPerson).pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.taxClassificationsCacheRepository.save(cacheId, transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
